<div class="grid-container margin-top margin-bottom-large wrapper">
  <form [formGroup]="form">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 large-12 medium-12 bold text-align-center">
        Search for Issues
      </div>
      <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
        Program Area:
      </div>
      <div class="cell small-6 medium-3 large-3 bold text-align-left padding-left">
        <select formControlName="programArea">
          @for (opt of programAreas; track opt) {
            <option [ngValue]="opt.id">{{opt.text}}</option>
          }
        </select>
      </div>
      <div class="cell small-12 large-6 medium-6">&nbsp;</div>
      <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
        Issue Description:
      </div>
      <div class="cell small-6 medium-9 large-9 text-align-left padding-left">
        <ng-select formControlName="issueType" [items]="types" bindValue="id" bindLabel="description" [placeholder]=""></ng-select>
      </div>
      <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
        RICS Owner Number:
      </div>
      <div class="cell small-6 medium-3 large-3 padding-left text-align-left">
        <input type="text" formControlName="ownerNumber" />
      </div>
      <div class="cell small-2 medium-1 large-1">
        <button class="button" (click)="lookupOwner('rics')" [disabled]="form?.get('ownerNumber')?.value?.length == 0 || orgSearchActive?.value || searchingIssues?.value">
          <svg-icon icon="icon-data-lookup" class="small black"></svg-icon>
        </button>
      </div>
      <div class="cell small-4 medium-5 large-5">
        @if (organization != null) {
          <span class="bold">Organization Found: {{organization?.name}}</span>
        }
        @if (orgNotFound.value) {
          <span class="bold red">Organization Not Found</span>
        }
      </div>
      <div class="cell small-6 medium-3 large-3 bold text-align-right padding-right">
        RBDMS Owner Number:
      </div>
      <div class="cell small-6 medium-3 large-3 padding-left text-align-left">
        <input type="text" formControlName="legacyOwnerNumber" />
      </div>
      <div class="cell small-2 medium-1 large-1">
        <button class="button" (click)="lookupOwner('legacy')" [disabled]="form?.get('legacyOwnerNumber')?.value?.length == 0 || orgSearchActive?.value || searchingIssues?.value">
          <svg-icon icon="icon-data-lookup" class="small black"></svg-icon>
        </button>
      </div>
      <div class="cell small-4 medium-5 large-5">
        <text-loader [run]="orgSearchActive?.value" [tickType]="'.'" [text]="'Searching'" [interval]="1000"></text-loader>
      </div>
      <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
        Created Date - From:
      </div>
      <div class="cell small-6 medium-3 large-3 padding-left">
        <common-date-picker [id]="'createdFrom'" (dateUpdated)="createdFromChanged($event)"></common-date-picker>
      </div>
      <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
        Created Date - To:
      </div>
      <div class="cell small-6 medium-3 large-3 padding-left">
        <common-date-picker  [id]="'createdTo'" (dateUpdated)="createdToChanged($event)"></common-date-picker>
      </div>
      <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
        Due Date - From:
      </div>
      <div class="cell small-6 medium-3 large-3 padding-left">
        <common-date-picker [id]="'dueFrom'" (dateUpdated)="dueFromChanged($event)"></common-date-picker>
      </div>
      <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
        Due Date - To:
      </div>
      <div class="cell small-6 medium-3 large-3 padding-left">
        <common-date-picker [id]="'dueTo'" (dateUpdated)="dueToChanged($event)"></common-date-picker>
      </div>
      <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
        Resolution Date - From:
      </div>
      <div class="cell small-6 medium-3 large-3 padding-left">
        <common-date-picker [id]="'resolvedFrom'" (dateUpdated)="resolvedFromChanged($event)"></common-date-picker>
      </div>
      <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
        Resolution Date - To:
      </div>
      <div class="cell small-6 medium-3 large-3 padding-left">
        <common-date-picker [id]="'resolvedTo'" (dateUpdated)="resolvedToChanged($event)"></common-date-picker>
      </div>
      <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
        Reporting Year - From:
      </div>
      <div class="cell small-6 medium-3 large-3 padding-left">
        <input type="number" min="2000" max="2100" formControlName="yearFrom" />
      </div>
      <div class="cell small-6 medium-3 large-3 bold padding-right text-align-right">
        Reporting Year - To:
      </div>
      <div class="cell small-6 medium-3 large-3 padding-left">
        <input type="number" min="2000" max="2100" formControlName="yearTo" />
      </div>
      <div class="cell small-12 large-12 medium-12 bold">
        Restrict to Quarters (select some, none, or all):
      </div>
      <div class="cell small-3 large-3 medium-3">
        <div class="checkbox">
          <input class="show-for-sr" id="q1" type="checkbox" formControlName="quarter1" />
          <label for="q1">
            1st Quarter: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
          </label>
        </div>
      </div>
      <div class="cell small-3 large-3 medium-3">
        <div class="checkbox">
          <input class="show-for-sr" id="q2" type="checkbox" formControlName="quarter2" />
          <label for="q2">
            2nd Quarter: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
          </label>
        </div>
      </div>
      <div class="cell small-3 large-3 medium-3">
        <div class="checkbox">
          <input class="show-for-sr" id="q3" type="checkbox" formControlName="quarter3" />
          <label for="q3">
            3rd Quarter: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
          </label>
        </div>
      </div>
      <div class="cell small-3 large-3 medium-3">
        <div class="checkbox">
          <input class="show-for-sr" id="q4" type="checkbox" formControlName="quarter4" />
          <label for="q4">
            4th Quarter: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
          </label>
        </div>
      </div>
      <div class="cell small-12 medium-12 large-12 italic">
        If a particular search takes an extraordinarily long time to complete, you may need to narrow your search criteria.
      </div>
      <div class="cell small-12 medium-12 large-12 text-align-center margin-top">
        <span class="minor-margin-right">
          <button class="button" (click)="reset()" [disabled]="searchingIssues?.value">Clear Form</button>
        </span>
        <span class="minor-margin-left">
          <button class="button" (click)="searchIssues()" [disabled]="searchingIssues?.value">Search for Issues</button>
        </span>
      </div>
      @for (error of formErrors; track error) {
        <div class="cell small-12 medium-12 large-12">
          <span class="red bold">{{error}}</span>
        </div>
      }

    </div>
  </form>
  @if (issueSearchRun?.value) {
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-12 large-12">
        <text-loader [run]="searchingIssues.value" [tickType]="'.'" [interval]="1500" [text]="'Searching for issues.. please wait'"></text-loader>
      </div>
      <div class="cell small-12 medium-12 large-12">
        <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data | async" [selectionColumnDef]="selectionColumnDef" [excelStyles]="excelStyles" aria-label="Issues Search"></ag-grid-angular>
      </div>
      <div class="cell small-12 medium-12 large-12 text-align-center">
        <button class="button" (click)="export()">Export Selected Rows</button>
      </div>
    </div>
  }
</div>